import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { IconNormal } from "./Icon";
import AppTheme from "../../../service/app_config/AppTheme";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { textCase } from "../../../service/ui/UI";
import CacheStorage from "../../../service/storage/CacheStorage";
import StorageKeys from "../../../const/StorageKeys";

type DropdownType = {
  icon: string;
  options: Array<OptionType>;
};

type OptionType = {
  title: string;
  subTitle?: string;
  onClick?: () => void;
};

export const DropdownAppAction: React.FC<DropdownType> = ({
  icon,
  options,
}) => {
  const lang: string | "en" | "ar" = CacheStorage.getValue(
    StorageKeys.language
  );

  return (
    <div>
      <DropdownButton
        align={lang === "ar" ? "start" : "end"}
        role="button"
        className="dropdown-menu-end"
        title={<IconNormal name={`${icon}`} color={AppTheme.themeFont} />}
      >
        {options.map((item, key) => (
          <Dropdown.Item key={key} onClick={item.onClick}>
            {AppTranslation.text(item.title)}
            {item.subTitle !== undefined &&
              UtilityHelper.isNotEmpty(item.subTitle) && (
                <div className="font-gotham-book font-size-10_12">
                  {textCase(item.subTitle)}
                </div>
              )}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </div>
  );
};

/* 
 <Dropdown align="end">
      <Dropdown.Toggle variant="secondary" id="dropdown-basic">
        Menu
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#">Action</Dropdown.Item>
        <Dropdown.Item href="#">Another action</Dropdown.Item>
        <Dropdown.Item href="#">Something else</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown> */
